<div class="billet-generate-audit" *ngIf="!rawJsonFallback">
  <div class="grid mb-3">
    <div class="col-12 md:col-6" *ngIf="payload['startedAt']">
      <strong>Início:</strong> {{ payload['startedAt'] }}
    </div>
    <div class="col-12 md:col-6" *ngIf="payload['finishedAt']">
      <strong>Fim:</strong> {{ payload['finishedAt'] }}
    </div>
    <div class="col-12 md:col-4" *ngIf="payload['marinaId'] != null">
      <strong>Marina:</strong> {{ payload['marinaId'] }}
    </div>
    <div class="col-12 md:col-4" *ngIf="payload['userId'] != null">
      <strong>Usuário:</strong> {{ payload['userId'] }}
    </div>
    <div class="col-12 md:col-4" *ngIf="payload['bililngPortifolioId'] != null">
      <strong>Carteira:</strong> {{ payload['bililngPortifolioId'] }}
    </div>
  </div>

  <div class="mb-3" *ngIf="payload['txtLogUrl']">
    <a [href]="payload['txtLogUrl']" target="_blank" rel="noopener">
      <i class="pi pi-file"></i> Baixar log texto
    </a>
  </div>

  <p-panel header="Resumo" [toggleable]="true" styleClass="mb-3" *ngIf="summary != null">
    <pre class="json-block">{{ asJson(summary) }}</pre>
  </p-panel>

  <p-panel header="Erro" [toggleable]="true" styleClass="mb-3 p-panel-error" *ngIf="error">
    <pre class="json-block">{{ asJson(error) }}</pre>
  </p-panel>

  <p-panel header="Passos" [toggleable]="true" styleClass="mb-3">
    <p-table [value]="steps" [paginator]="steps.length > 8" [rows]="8" responsiveLayout="scroll">
      <ng-template pTemplate="header">
        <tr>
          <th>Quando</th>
          <th>Ação</th>
          <th>Detalhe</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr>
          <td>{{ row['timestamp'] }}</td>
          <td>{{ row['action'] }}</td>
          <td>{{ row['detail'] }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="3">Nenhum passo registrado.</td>
        </tr>
      </ng-template>
    </p-table>
  </p-panel>

  <p-panel header="Faturas" [toggleable]="true" styleClass="mb-3">
    <p-table [value]="invoices" [paginator]="invoices.length > 8" [rows]="8" responsiveLayout="scroll">
      <ng-template pTemplate="header">
        <tr>
          <th>Fatura</th>
          <th>Nº</th>
          <th>Decisão</th>
          <th>Motivo</th>
          <th>Nosso Número</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr>
          <td>{{ row['invoiceId'] }}</td>
          <td>{{ row['invoiceNumber'] }}</td>
          <td>{{ decisionLabel(row['decision']) }}</td>
          <td>{{ row['reason'] }}</td>
          <td>{{ row['nossoNumero'] }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="5">Nenhuma fatura no relatório.</td>
        </tr>
      </ng-template>
    </p-table>
  </p-panel>
</div>

<div *ngIf="rawJsonFallback">
  <p class="mb-2">Formato de relatório não reconhecido; exibindo JSON bruto.</p>
  <pre class="json-block">{{ rawJsonFallback }}</pre>
</div>
